import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonCol, IonRow } from '@ionic/angular/standalone';
import { SharedModule } from 'src/app/components/shared/shared.module';
import { SharedReportsModule } from '../../shared/shared-reports.module';
import { GroupSummaryComponent } from './group-summary/group-summary.component';
import { LocationSummaryComponent } from './location-summary/location-summary.component';

@NgModule({
  declarations: [LocationSummaryComponent, GroupSummaryComponent],
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    ReactiveFormsModule,
    SharedReportsModule,
    IonCol,
    IonRow,
  ],
})
export class SummariesModule {}
